import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/contact_management'
import * as AppActions from 'actions/app'

import {
  ContactManagementContactsDataGridColumnVisibility
} from 'static/constants'

export const initialState = fromJS({
  settings: {
    density: 'standard',
    filterModel: {
      items: []
    },
    sortModel: [{
      field: 'createdAt',
      sort: 'desc'
    }],
    rowSelectionModel: [],
    columnVisibilityModel: ContactManagementContactsDataGridColumnVisibility.DEFAULT,
    pageSizeOptions: [25, 50, 100, 250, 500],
    paginationModel: {
      page: 0,
      pageSize: 25
    }
  }
})

export default handleActions(
  {
    [Actions.setSelectedMainTab]: (state, { payload }) => {
      // Reset selection if leaving 'contacts' tab
      if (payload === 'distribution_lists') {
        return state.setIn(['settings', 'rowSelectionModel'], fromJS([]))
      }

      return state
    },
    [Actions.setContactsDataGridSettings]: (state, { payload: { key, value } }) => (
      state.setIn(['settings', key], fromJS(value))
    ),
    [combineActions(
      Actions.clearSelectedContacts,
      Actions.deleteContactsSuccess
    )]: state => state.setIn(['settings', 'rowSelectionModel'], fromJS([])),

    [combineActions(
      Actions.resetState,
      AppActions.resetState
    )]: () => initialState
  },
  initialState
)
